import React, { useState } from 'react';
import './TeamBISection.css';

const TABS = [
  {
    id: 'ai',
    title: 'Placeholder 1',
    body:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus lacinia odio vitae vestibulum vestibulum.',
    image: '/bi-ai.png',
  },
  {
    id: 'share',
    title: 'Placeholder 2',
    body:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus lacinia odio vitae vestibulum vestibulum.',
    image: '/bi-share.png',
  },
  {
    id: 'guide',
    title: 'Placeholder 3',
    body:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus lacinia odio vitae vestibulum vestibulum.',
    image: '/bi-guide.png',
  },
];

export default function TeamBISection() {
  const [active, setActive] = useState(TABS[0].id);

  const current = TABS.find(t => t.id === active);

  return (
    <section className="team-bi">
      {/* Header */}
      <div className="team-bi-header">
        <h2>Placeholder Text</h2>
        <p>
          <span>This is placeholder text. Lorem ipsum dolor sit, amet consectetur adipisicing elit. Dolore!</span>
        </p>
      </div>

      {/* Content */}
      <div className="team-bi-content">
        {/* Left tabs */}
        <div className="team-bi-tabs">
          {TABS.map(tab => (
            <button
              key={tab.id}
              className={`team-bi-tab ${
                tab.id === active ? 'is-active' : ''
              }`}
              onClick={() => setActive(tab.id)}
            >
              <h4>{tab.title}</h4>
              <p>{tab.body}</p>
            </button>
          ))}
        </div>

        {/* Right image */}
        <div className="team-bi-visual">
          {/* <img src={current.image} alt={current.title} /> */}
        </div>
      </div>
    </section>
  );
}
